var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path, _path2, _path3, _g2, _g3, _g4, _g5, _g6, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbroad01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2568",
    "data-name": "Group 2568",
    xmlns: "http://www.w3.org/2000/svg",
    width: 117.58,
    height: 106.999,
    viewBox: "0 0 117.58 106.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2558",
    "data-name": "Group 2558",
    transform: "translate(58.058 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_925",
    "data-name": "Rectangle 925",
    width: 1.465,
    height: 18.14,
    fill: "#34495e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_926",
    "data-name": "Rectangle 926",
    width: 11.368,
    height: 6.769,
    transform: "translate(1.465 0.201)",
    fill: "#f1c40f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_927",
    "data-name": "Rectangle 927",
    width: 11.368,
    height: 3.385,
    transform: "translate(1.465 0.201)",
    fill: "#e74c3c"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_928",
    "data-name": "Rectangle 928",
    width: 117.58,
    height: 7.746,
    transform: "translate(0 99.252)",
    fill: "#f9b316"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_929",
    "data-name": "Rectangle 929",
    width: 117.58,
    height: 4.72,
    transform: "translate(0 35.577)",
    fill: "#f9b316"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_930",
    "data-name": "Rectangle 930",
    width: 112.1,
    height: 58.955,
    transform: "translate(2.74 40.297)",
    fill: "#95a5a6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_931",
    "data-name": "Rectangle 931",
    width: 112.1,
    height: 56.681,
    transform: "translate(2.74 42.571)",
    fill: "#ced4d9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_932",
    "data-name": "Rectangle 932",
    width: 62.658,
    height: 58.955,
    transform: "translate(27.461 40.297)",
    fill: "#e3e7e8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_933",
    "data-name": "Rectangle 933",
    width: 55.992,
    height: 58.955,
    transform: "translate(30.794 40.297)",
    fill: "#3f2566"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_934",
    "data-name": "Rectangle 934",
    width: 66.585,
    height: 3.39,
    transform: "translate(25.497 40.297)",
    fill: "#ecf0f1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_935",
    "data-name": "Rectangle 935",
    width: 53,
    height: 5.054,
    transform: "translate(32.29 44.15)",
    fill: "#202d3b"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_936",
    "data-name": "Rectangle 936",
    width: 64.685,
    height: 1.695,
    transform: "translate(26.448 43.687)",
    fill: "#ecf0f1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_937",
    "data-name": "Rectangle 937",
    width: 66.585,
    height: 3.391,
    transform: "translate(25.497 91.78)",
    fill: "#ecf0f1"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_938",
    "data-name": "Rectangle 938",
    width: 64.685,
    height: 1.695,
    transform: "translate(26.448 90.085)",
    fill: "#ecf0f1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4163",
    "data-name": "Path 4163",
    d: "M184.428,28.323,143.535,59.551h81.787Z",
    transform: "translate(-125.638 -19.254)",
    fill: "#f9b316"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4164",
    "data-name": "Path 4164",
    d: "M182.605,30.562l-36.137,27.6h72.274Z",
    transform: "translate(-123.815 -17.861)",
    fill: "#95a5a6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4165",
    "data-name": "Path 4165",
    d: "M182.929,32.136,148.179,57.18h69.5Z",
    transform: "translate(-122.751 -16.883)",
    fill: "#e3e7e8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2559",
    "data-name": "Group 2559",
    transform: "translate(7.383 46.294)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_939",
    "data-name": "Rectangle 939",
    width: 1.78,
    height: 14.661,
    transform: "translate(15.244 16.203) rotate(90)",
    fill: "#95a5a6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_940",
    "data-name": "Rectangle 940",
    width: 1.78,
    height: 14.661,
    transform: "translate(14.661 15.313) rotate(90)",
    fill: "#ecf0f1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_941",
    "data-name": "Rectangle 941",
    width: 16.187,
    height: 12.974,
    transform: "translate(13.818 0) rotate(90)",
    fill: "#ecf0f1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_942",
    "data-name": "Rectangle 942",
    width: 10.606,
    height: 12.943,
    transform: "translate(2.027 1.622)",
    fill: "#2980b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4166",
    "data-name": "Path 4166",
    d: "M148.909,52.868v-.592H138.3V64.542A68.193,68.193,0,0,1,148.909,52.868Z",
    transform: "translate(-136.275 -50.654)",
    fill: "#3498db"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2560",
    "data-name": "Group 2560",
    transform: "translate(7.383 67.074)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_943",
    "data-name": "Rectangle 943",
    width: 1.781,
    height: 14.661,
    transform: "translate(15.244 16.202) rotate(90)",
    fill: "#95a5a6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_944",
    "data-name": "Rectangle 944",
    width: 1.78,
    height: 14.661,
    transform: "translate(14.661 15.312) rotate(90)",
    fill: "#ecf0f1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_945",
    "data-name": "Rectangle 945",
    width: 16.187,
    height: 12.974,
    transform: "translate(13.818 0) rotate(90)",
    fill: "#ecf0f1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_946",
    "data-name": "Rectangle 946",
    width: 10.606,
    height: 12.943,
    transform: "translate(2.027 1.622)",
    fill: "#2980b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4167",
    "data-name": "Path 4167",
    d: "M148.909,65.682v-.594H138.3V77.354A68.242,68.242,0,0,1,148.909,65.682Z",
    transform: "translate(-136.275 -63.468)",
    fill: "#3498db"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2561",
    "data-name": "Group 2561",
    transform: "translate(95.836 46.294)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_947",
    "data-name": "Rectangle 947",
    width: 1.78,
    height: 14.661,
    transform: "translate(15.244 16.203) rotate(90)",
    fill: "#95a5a6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_948",
    "data-name": "Rectangle 948",
    width: 1.78,
    height: 14.661,
    transform: "translate(14.661 15.313) rotate(90)",
    fill: "#ecf0f1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_949",
    "data-name": "Rectangle 949",
    width: 16.187,
    height: 12.974,
    transform: "translate(13.818 0) rotate(90)",
    fill: "#ecf0f1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_950",
    "data-name": "Rectangle 950",
    width: 10.606,
    height: 12.943,
    transform: "translate(2.027 1.622)",
    fill: "#2980b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4168",
    "data-name": "Path 4168",
    d: "M203.449,52.868v-.592H192.842V64.542A68.194,68.194,0,0,1,203.449,52.868Z",
    transform: "translate(-190.815 -50.654)",
    fill: "#3498db"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2562",
    "data-name": "Group 2562",
    transform: "translate(95.836 67.074)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_951",
    "data-name": "Rectangle 951",
    width: 1.781,
    height: 14.661,
    transform: "translate(15.244 16.202) rotate(90)",
    fill: "#95a5a6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_952",
    "data-name": "Rectangle 952",
    width: 1.78,
    height: 14.661,
    transform: "translate(14.661 15.312) rotate(90)",
    fill: "#ecf0f1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_953",
    "data-name": "Rectangle 953",
    width: 16.187,
    height: 12.974,
    transform: "translate(13.818 0) rotate(90)",
    fill: "#ecf0f1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_954",
    "data-name": "Rectangle 954",
    width: 10.606,
    height: 12.943,
    transform: "translate(2.027 1.622)",
    fill: "#2980b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4169",
    "data-name": "Path 4169",
    d: "M203.449,65.682v-.594H192.842V77.354A68.243,68.243,0,0,1,203.449,65.682Z",
    transform: "translate(-190.815 -63.468)",
    fill: "#3498db"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2567",
    "data-name": "Group 2567",
    transform: "translate(16.148 95.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2563",
    "data-name": "Group 2563",
    transform: "translate(7.224)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_955",
    "data-name": "Rectangle 955",
    width: 70.835,
    height: 3.07,
    fill: "#bdc3c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2564",
    "data-name": "Group 2564",
    transform: "translate(4.964 2.919)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_956",
    "data-name": "Rectangle 956",
    width: 75.356,
    height: 3.071,
    fill: "#f0f4f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2565",
    "data-name": "Group 2565",
    transform: "translate(2.559 5.838)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_957",
    "data-name": "Rectangle 957",
    width: 80.166,
    height: 3.071,
    fill: "#bdc3c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2566",
    "data-name": "Group 2566",
    transform: "translate(0 8.758)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_958",
    "data-name": "Rectangle 958",
    width: 85.284,
    height: 3.07,
    fill: "#f0f4f5"
  })))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_959",
    "data-name": "Rectangle 959",
    width: 7.133,
    height: 44.702,
    transform: "translate(31.877 45.383)",
    fill: "#202d3b"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_960",
    "data-name": "Rectangle 960",
    width: 7.132,
    height: 44.702,
    transform: "translate(49.574 45.383)",
    fill: "#202d3b"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_961",
    "data-name": "Rectangle 961",
    width: 7.132,
    height: 44.702,
    transform: "translate(67.271 45.383)",
    fill: "#202d3b"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_962",
    "data-name": "Rectangle 962",
    width: 7.133,
    height: 44.702,
    transform: "translate(28.633 45.383)",
    fill: "#ecf0f1"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_963",
    "data-name": "Rectangle 963",
    width: 7.132,
    height: 44.702,
    transform: "translate(46.331 45.383)",
    fill: "#ecf0f1"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_964",
    "data-name": "Rectangle 964",
    width: 7.132,
    height: 44.702,
    transform: "translate(64.027 45.383)",
    fill: "#ecf0f1"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_965",
    "data-name": "Rectangle 965",
    width: 7.133,
    height: 44.702,
    transform: "translate(81.723 45.383)",
    fill: "#ecf0f1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbroad01);
export default __webpack_public_path__ + "static/media/abroad-01.c8469c3a57b2c72e0a9dde58f86c46ab.svg";
export { ForwardRef as ReactComponent };